import { Component, Input } from '@angular/core';

@Component({
  selector: 'page-title',
  template: `<h2 translate class="text-center">{{title}}</h2>`,
})
export class TitleComponent {
  @Input('title') title: string;
}
